module.exports = __webpack_public_path__ + "img/banner_com.7cb139f8.png";